module.exports = __webpack_public_path__ + "static/img/zwrjmfm.e3234e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/zwrjmfm.png
// module id = DPdu
// module chunks = 1